import React from "react";
import { Helmet } from "react-helmet";
// icons
import qualityIcon from "../assets/otherimages/Variable Pricing.png";
import priceIcon from "../assets/otherimages/Doorstep Delivery.png";
import supportIcon from "../assets/otherimages/Technical Support.png";
import bookingIcon from "../assets/otherimages/Roadside Assistance.png";

const WhyChooseUs = () => {
  const features = [
    {
      icon: qualityIcon,
      title: "Variable Pricing",
      description:
        "Enjoy flexible rental rates tailored to your needs—daily, weekly, monthly, or yearly. Pay only for what you use with transparent, competitive pricing.",
    },
    {
      icon: priceIcon,
      title: "Doorstep Delivery",
      description:
        "Skip the hassle—your chosen vehicle can be delivered right to your home, office, or hotel at your convenience.",
    },
    {
      icon: supportIcon,
      title: "Technical Support",
      description:
        "Our dedicated support team is always ready to assist you with any vehicle-related questions or concerns.",
    },
    {
      icon: bookingIcon,
      title: "Roadside Assistance",
      description:
        "Drive with peace of mind knowing that roadside help is just a call away in case of emergencies.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Why Choose Us | Blue Diamond Rent Car Dubai</title>
        <meta
          name="description"
          content="Discover why Blue Diamond Rent Car is trusted across Dubai — variable pricing, doorstep delivery, technical support, and roadside assistance."
        />
        <link rel="canonical" href="https://bluediamondrentcar.com/why" />
      </Helmet>
      <section
        id="why"
        className="py-16 px-6 sm:px-8 md:px-18 lg:px-16 xl:px-20 bg-white"
      >
        <div className="container mx-auto text-center">
          {/* Section Title */}
          <h2 className="text-2xl md:text-3xl font-bold text-[#0B2F6B] mb-4">
            WHY CHOOSE US
          </h2>
          <p className="text-[#123775] mb-12 text-lg md:text-xl">
            We make car rentals simple, affordable, and reliable
          </p>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md border border-gray-200 p-8 flex flex-col items-center text-center transition-transform duration-300 ease-in-out hover:-translate-y-2 hover:shadow-lg hover:bg-blue-50"
              >
                {/* Icon */}
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="h-24 w-auto mb-6 transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />

                {/* Title */}
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h4>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
